import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

//datepicker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//middelware
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import Axios from "axios";
import moment from "moment";

//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";

import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { ROUTES } from "../../../../utils/routes";
import Swal from "sweetalert2";
import { paths } from "../../../../utils/paths";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { validate } from "./validations";
import { PdfUploader } from "../../../../components/FileUploader/PdfUploader";
import { ArchiveUploader } from "../../../../components/FileUploader/ArchiveUploader";

export const ManageNews = () => {
  const { COMMUNICATIONS, PROJECTS } = paths;
  const { id } = useParams();
  const { deleteIt } = useDelete();

  let { staffId, isAdmin, userId } = useSelector(({ user }) => user);

  const history = useHistory();
  const [isCreate, setIsCreate] = useState(false);

  const [titleEs, setTitleEs] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleVa, setTitleVa] = useState("");
    const [subtitleEs, setSubtitleEs] = useState("");
    const [subtitleEn, setSubtitleEn] = useState("");
    const [subtitleVa, setSubtitleVa] = useState("");
  const [textEs, setTextEs] = useState("");
  const [textEn, setTextEn] = useState("");
  const [textVa, setTextVa] = useState("");
  const [url, setUrl] = useState("");  
  const [aparecerActualidad, setAparecerActualidad] = useState('')
  const [creatorId, setCreatorId] = useState(null);
  const [fechaHora, setFechaHora] = useState(new Date());
  const [fechaInicio, setFechaInicio] = useState(new Date());
  const [fechaFin, setFechaFin] = useState(new Date());
  const [carrousel, setCarrousel] = useState();
  const [cartelNotaPrensa, setCartelNotaPrensa] = useState()
  const [adjunto, setAdjunto] = useState()
  const [notaDePrensa, setNotaDePrensa] = useState()
  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMountedRef.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? setIsCreate(true) : loadData();
    // loadStaticData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadData = async () => {
    try {
      let response = await getById(COMMUNICATIONS, id, source);
      isMountedRef.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  // prettier-ignore
  const buildObjToLoad = (response) => {
    const {
      titleEn,
      titleEs,
      titleVa,
      subtitleEs,
      subtitleEn,
      subtitleVa,
      textEn,
      textEs,
      textVa,
      url,
      aparecerActualidad,
      carrousel,
      cartelNotaPrensa,
      adjunto,
      notaDePrensa,
      fechaHora,
      fechaInicio,
      fechaFin
    } = response;
    const {user: { id: userId }} = response;

	const dateWithOffset = new Date(fechaHora);
	const dateNoOffset = ( new Date( dateWithOffset.getTime() - dateWithOffset.getTimezoneOffset() * -60000 ));
  const initdateWithOffset = new Date(fechaInicio);
  const initdateNoOffset = new Date(initdateWithOffset.getTime() - initdateWithOffset.getTimezoneOffset() * -60000);
  const enddateWithOffset = new Date(fechaFin);
  const enddateNoOffset = new Date(enddateWithOffset.getTime() - enddateWithOffset.getTimezoneOffset() * -60000);
    setTitleEn(titleEn);
    setTitleEs(titleEs);
	  setTitleVa(titleVa);
    setSubtitleEs(subtitleEs);
    setSubtitleEn(subtitleEn);
    setSubtitleVa(subtitleVa)
    setUrl(url);
    setCreatorId(userId);
    setCarrousel(carrousel);
    setCartelNotaPrensa(cartelNotaPrensa)
    setAdjunto(adjunto)
    setNotaDePrensa(notaDePrensa)
    setFechaHora(dateNoOffset);
    setFechaInicio(initdateNoOffset)
    setFechaFin(enddateNoOffset)
	setTextEs(textEs);
	setTextEn(textEn);
	setTextVa(textVa);
  setAparecerActualidad(aparecerActualidad ? '1' : '0')

	if (isMountedRef.current) 
	setAllowedEdit(true);
  };

  const handleSubmit = () => {
    const news = build();
//     const notValid = validate(news);
//     if (notValid) {
//       setMessage(notValid);
//       setTimeout(() => setMessage(""), 4000);
//       return;
//     }
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} noticia?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleConfirmation(news, carrousel, cartelNotaPrensa, adjunto, notaDePrensa);
    });
  };

  const handleConfirmation = (news, carrousel,cartelNotaPrensa, adjunto, notaDePrensa) => {
    let createOrUpdate = isCreate
      ? create(COMMUNICATIONS, news, source)
      : update(COMMUNICATIONS, id, news, source);
    createOrUpdate
      .then(async ({ id }) => {
        Swal.fire({
          icon: "success",
          text: `Noticia ${isCreate ? "creada" : "editada"} correctamente.`,
        });
        if (typeof carrousel !== "string") {
          const formData = new FormData();
          formData.append("image", carrousel);
          await saveFile(COMMUNICATIONS, id, "carrousel", formData, source);
        }
        
	  if (typeof cartelNotaPrensa !== "string") {
      const formData = new FormData();
      formData.append("image", cartelNotaPrensa);
      await saveFile(COMMUNICATIONS, id, "cartel-nota-prensa", formData, source);
    }
    if (typeof adjunto !== "string") {
      const formData = new FormData();
      formData.append("document", adjunto);
      await saveFile(COMMUNICATIONS, id, "adjunto", formData, source);
    }
       if (typeof notaDePrensa !== "string") {
         const formData = new FormData();
         formData.append("document", notaDePrensa);
         await saveFile(COMMUNICATIONS, id, "nota-de-prensa", formData, source);
       }
        history.push(`${ROUTES.News.all}/${id}`);
        setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const build = () => {
    return {
      userId: creatorId ? creatorId : userId,
      titleEs,
      titleEn,
      titleVa,
      subtitleEs,
      subtitleEn,
      subtitleVa,
      fechaHora: moment(fechaHora).format("YYYY-MM-DD"),
      fechaInicio: moment(fechaInicio).format("YYYY-MM-DD"),
      fechaFin: moment(fechaFin).format("YYYY-MM-DD"),
      url,
      textEs,
      textEn,
      textVa,
      aparecerActualidad: aparecerActualidad === "1" ? true : false,
    };
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Noticia
        </button>
      );
    }
    if ((!isCreate && userId === creatorId) || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() =>
              deleteIt(COMMUNICATIONS, id, ROUTES.News.all, source)
            }
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

 

  return (
    <div className="centerPage">
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div>
              <h3>Noticia </h3>
            </div>
            <div>{editDeleteButtons()}</div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Imágen para slider de la web</small>
            <FileUploader handleFile={setCarrousel} image={carrousel} />
          </div>
          <div className="col">
            <small>Imágen destacada de la noticia</small>
            <FileUploader
              handleFile={setCartelNotaPrensa}
              image={cartelNotaPrensa}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Archivo adjunto</small>
            <ArchiveUploader handleFile={setAdjunto} archive={adjunto} />
          </div>
          <div className="col">
            <small>Nota de prensa</small>
            <ArchiveUploader
              handleFile={setNotaDePrensa}
              archive={notaDePrensa}
            />
          </div>

          <div className="form-row ">
            <div className="col">
              <small>Url de la noticia</small>
              <input
                type="text"
                className="form-control"
                placeholder="Url"
                value={url}
                onChange={({ target: { value } }) => {
                  setUrl(value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>*Fecha de publicación</small>
            <DatePicker
              className="form-control input"
              placeholderText="*Fecha"
              selected={fechaHora}
              onChange={(fechaHora) => setFechaHora(fechaHora)}
              dateFormat="dd MMMM, yyyy"
              isClearable
              locale="es"
              dropdownMode="select"
              showMonthDropdown
              showYearDropdown
              adjustDateOnChange
            />
          </div>
          <div className="col">
            <small>Visible en últimas noticias?</small>
            <select
              className="form-control input"
              value={aparecerActualidad}
              onChange={({ target: { value } }) => {
                setAparecerActualidad(value);
              }}
            >
              <option value="">Seleccione una opción</option>
              <option value="0">No</option>
              <option value="1">Si</option>
            </select>
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>*Título español</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título español"
              value={titleEs}
              onChange={({ target: { value } }) => {
                setTitleEs(value);
              }}
            />
          </div>
          <div className="col">
            <small>*Título inglés</small>
            <input
              type="text"
              className="form-control"
              placeholder="Título inglés"
              value={titleEn}
              onChange={({ target: { value } }) => {
                setTitleEn(value);
              }}
            />
          </div>
          <div className="col">
            <small>*Título valenciano</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título valenciano"
              value={titleVa}
              onChange={({ target: { value } }) => {
                setTitleVa(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Subtítulo español</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Subítulo español"
              value={subtitleEs}
              onChange={({ target: { value } }) => {
                setSubtitleEs(value);
              }}
            />
          </div>
          <div className="col">
            <small>*Subítulo inglés</small>
            <input
              type="text"
              className="form-control"
              placeholder="Subítulo inglés"
              value={subtitleEn}
              onChange={({ target: { value } }) => {
                setSubtitleEn(value);
              }}
            />
          </div>
          <div className="col">
            <small>*Subtítulo valenciano</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Subítulo valenciano"
              value={subtitleVa}
              onChange={({ target: { value } }) => {
                setSubtitleVa(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-4">
          <div className="col">
            <small>*Fecha de inicio</small>
            <DatePicker
              className="form-control input"
              placeholderText="*Fecha de inicio"
              selected={fechaInicio}
              onChange={(fechaInicio) => setFechaInicio(fechaInicio)}
              dateFormat="dd MMMM, yyyy"
              isClearable
              locale="es"
              dropdownMode="select"
              showMonthDropdown
              showYearDropdown
              adjustDateOnChange
            />
          </div>
          <div className="col">
            <small>*Fecha de fin de visualización</small>
            <DatePicker
              className="form-control input"
              placeholderText="*Fecha de fin de visualización"
              selected={fechaFin}
              onChange={(fechaFin) => setFechaFin(fechaFin)}
              dateFormat="dd MMMM, yyyy"
              isClearable
              locale="es"
              dropdownMode="select"
              showMonthDropdown
              showYearDropdown
              adjustDateOnChange
            />
          </div>
        </div>
        {(isCreate || allowedEdit) && (
          <>
            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en español</small>
                <CKEditor
                  initData={textEs}
                  config={editorConfig}
                  onChange={({ editor }) => {
                    setTextEs(editor.getData());
                  }}
                />
              </div>
            </div>

            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en inglés</small>
                <CKEditor
                  initData={textEn}
                  config={editorConfig}
                  onChange={({ editor }) => {
                    setTextEn(editor.getData());
                  }}
                />
              </div>
            </div>
            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en valenciano</small>
                <CKEditor
                  initData={textVa}
                  config={editorConfig}
                  onChange={({ editor }) => {
                    setTextVa(editor.getData());
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
